export default "__VITE_ASSET__CmLiXBv5__"